import { useRef, useState, useEffect } from "react";

export type ShadowVisibleChange = (state: {
  topShadowVisible: boolean;
  bottomShadowVisible: boolean;
}) => void;

export function useShadowVisible(onChange?: ShadowVisibleChange) {
  const topShadowRef = useRef<HTMLDivElement>(null);
  const bottomShadowRef = useRef<HTMLDivElement>(null);

  const [topShadowVisible, setTopShadowVisible] = useState(false);
  const [bottomShadowVisible, setBottomShadowVisible] = useState(false);

  useEffect(() => {
    onChange?.({
      topShadowVisible,
      bottomShadowVisible,
    });
  }, [onChange, topShadowVisible, bottomShadowVisible]);

  useEffect(() => {
    if (!topShadowRef.current || !bottomShadowRef.current) {
      return;
    }

    const topShadowObserver = new IntersectionObserver(([entry]) => {
      if (entry) {
        setTopShadowVisible(!entry.isIntersecting);
      }
    });

    const bottomShadowObserver = new IntersectionObserver(([entry]) => {
      if (entry) {
        setBottomShadowVisible(!entry.isIntersecting);
      }
    });

    topShadowObserver.observe(topShadowRef.current);
    bottomShadowObserver.observe(bottomShadowRef.current);

    return () => {
      topShadowObserver.disconnect();
      bottomShadowObserver.disconnect();
    };
  }, []);

  return {
    topShadowRef,
    bottomShadowRef,
    topShadowVisible,
    bottomShadowVisible,
  };
}
